/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EngineDetailResponseDto } from '../models/EngineDetailResponseDto';
import type { EngineRequestDto } from '../models/EngineRequestDto';
import type { EngineResponseDto } from '../models/EngineResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EngineControllerService {

    /**
     * Получение двигателя по id
     * @param id
     * @returns EngineDetailResponseDto OK
     * @throws ApiError
     */
    public static findEngineById(
        id: number,
    ): CancelablePromise<EngineDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/engines/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Обновление двигателя
     * @param id
     * @param requestBody
     * @returns EngineDetailResponseDto OK
     * @throws ApiError
     */
    public static updateEngine(
        id: number,
        requestBody: EngineRequestDto,
    ): CancelablePromise<EngineDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/engines/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Удаление двигателя
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteEngine(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/engines/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Получение двигателей с фильтрацией
     * @param userId
     * @param engineType
     * @returns EngineResponseDto Двигатели успешно получены
     * @throws ApiError
     */
    public static findEngines(
        userId?: number,
        engineType?: string,
    ): CancelablePromise<Array<EngineResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/engines',
            query: {
                'userId': userId,
                'engineType': engineType,
            },
        });
    }

    /**
     * Создание двигателя
     * @param requestBody
     * @returns EngineDetailResponseDto OK
     * @throws ApiError
     */
    public static createEngine(
        requestBody: EngineRequestDto,
    ): CancelablePromise<EngineDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/engines',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
